var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 27,
    className: "color2Stroke",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3099 38.1844C36.1774 38.1844 35.9941 38.0948 35.765 37.9175L27.1862 30.861C27.0107 30.668 26.8613 30.4083 26.7742 30.1451L26.7582 30.1006L26.7378 30.0552L26.7291 30.0402C26.5856 29.7961 26.5066 29.5335 26.4944 29.26L27.6756 14.0622C27.8 12.9731 28.0531 12.8641 28.6443 12.8641C29.249 12.8641 29.4875 12.9628 29.5927 14.0111L30.7257 28.744L37.1129 36.5915C37.424 36.9944 37.5393 37.1993 36.9622 37.7765C36.6915 38.0472 36.4722 38.1844 36.3099 38.1844Z",
    className: "baseColor2Fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.04c20b536c11c9e7ac30b36d669cd996.svg";
export { ForwardRef as ReactComponent };